import { loadStripe, type Stripe } from '@stripe/stripe-js';

const rawStripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const stripePublishableKey =
  typeof rawStripePublishableKey === 'string' ? rawStripePublishableKey.trim() : '';

export const isStripeConfigured = stripePublishableKey.length > 0;

export const stripePromise: Promise<Stripe | null> = isStripeConfigured
  ? loadStripe(stripePublishableKey)
  : Promise.resolve(null);
